import React from "react";
import { Reveal, RevealImage } from "@/lib/motion";
import { Page, PageHero, Overline, CTABand } from "@/components/shared";
import { useContent, buildWa } from "@/lib/ContentProvider";
import { ArrowUpRight } from "lucide-react";

export default function Treatments() {
  const { services, siteConfig } = useContent();
  return (
    <Page testid="treatments-page">
      <PageHero
        overline="Diseases & Treatments"
        titleLines={["Advanced laser", <span key="2">& <span className="italic text-alch-terracotta">laparoscopic</span> care</span>]}
        subtitle="Precision technology, expert hands, faster recovery — explore our full range of minimally invasive treatments."
      />

      <section className="px-5 py-24 md:px-8 md:py-32">
        <div className="mx-auto max-w-7xl space-y-24">
          {services.map((s, i) => (
            <div key={s.key || s.title} data-testid={`treatment-${s.key || i}`} className={`grid items-center gap-12 lg:grid-cols-2 ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Reveal>
                <RevealImage src={s.image} alt={s.title} className="h-[24rem] rounded-[2rem]" />
              </Reveal>
              <div>
                <Overline>{`0${i + 1}`}</Overline>
                <Reveal>
                  <h2 className="mt-4 font-serif text-4xl leading-tight text-alch-forest md:text-5xl">{s.title}</h2>
                </Reveal>
                <ul className="mt-8 space-y-4">
                  {(s.items || []).map((it, j) => (
                    <Reveal key={it} delay={j * 0.06}>
                      <li className="flex items-start gap-3 border-b border-alch-forest/10 pb-4 text-lg text-alch-ink/85">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-alch-terracotta" />
                        {it}
                      </li>
                    </Reveal>
                  ))}
                </ul>
                <Reveal delay={0.2}>
                  <a href={buildWa(siteConfig.whatsapp, `Hello, I'd like to know more about ${s.title}.`)} target="_blank" rel="noreferrer"
                    className="group mt-8 inline-flex items-center gap-2 rounded-full bg-alch-forest px-6 py-3.5 text-sm font-medium text-alch-bg transition-transform hover:scale-[1.04]">
                    Enquire on WhatsApp
                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </Page>
  );
}
